import { retrieveNCavitesByUser, retrieveCavitesByQuery } from '@/lib/services';
import CavCavite from '@/lib/models/cav-cavite';
import { RootState } from '@/store';
import BeanQueryResult from '@/lib/models/bean-query-result';
import { RetrieveCavitesByQueryBody } from '@/lib/services/bodies';
import { clone } from "lodash";
import Query from '@/lib/models/query';

export type HomeState = {
  userCavites: CavCavite[];
  queryResult: BeanQueryResult;
  query: Query;
  currentPage: number;
  lastRetrieveCavitesByQueryBody: RetrieveCavitesByQueryBody;
  loading: {
    userCavites: number,
    queriedCavites: number
  };
}

export default {
  state: {
    userCavites: [],
    queryResult: new BeanQueryResult().inject({cavites: [], totalSize: 0}),
    query: new Query(),
    currentPage: 0,
    lastRetrieveCavitesByQueryBody: null,
    loading: {
      userCavites: 0,
      queriedCavites: 0
    },
  },
  mutations: {
    startFetchUserCavites(state: HomeState) {
      state.loading.userCavites++;
    },
    setUserCavites(state: HomeState, data) {
      state.userCavites = data;
      state.loading.userCavites--;
    },
    startQueryingCavites(state: HomeState) {
      state.lastRetrieveCavitesByQueryBody = clone({query: state.query, page: state.currentPage});
      state.loading.queriedCavites++;
    },
    setQueryResult(state: HomeState, data) {
      state.queryResult = data;
      state.loading.queriedCavites--;
    },
    setCurrentPage(state: HomeState, idx) {
      state.currentPage = idx;
    }
  },
  actions: {
    async loadUserCavites({commit, rootState}: {commit: any, rootState: RootState}) {
      commit("startFetchUserCavites");
      commit("setUserCavites", await retrieveNCavitesByUser({userId: rootState.login.loggedUser.mail, n: 10}));
    },
    async retrieveCavitesByQuery({commit, state}: {commit: any, state: HomeState}, page?: number) {
      if (page != null) {
        commit("setCurrentPage", page);
      }
      commit("startQueryingCavites");
      commit("setQueryResult", await retrieveCavitesByQuery({query: state.query, page: state.currentPage}));
    },
    async refreshLastFetched({dispatch, state}: {dispatch: any, state: HomeState}) {
      if (this.lastRetrieveCavitesByQueryBody) {
        state.query = this.lastRetrieveCavitesByQueryBody.query;
        state.currentPage = this.lastRetrieveCavitesByQueryBody.page;
      }
      await dispatch("retrieveCavitesByQuery");
      await dispatch("loadUserCavites");
    },
    async setCurrentPage({commit, dispatch}, idx) {
      commit("setCurrentPage", idx);
      dispatch("retrieveCavitesByQuery");
    }
  }
};
